<script lang="ts">
import type { Attachment } from '@smartsupp/smartsupp-message'
import { getContext } from 'svelte'

import { isTouchDevice } from '@/modules/device'
import { isMessengerFrameExpanded } from '@/modules/frames'
import { contentMessageAttachmentKey, type WritableMessageAttachmentContext } from '@/modules/messages'

import Carousel from '../carousel/Carousel.svelte'
import Card from './Card.svelte'

let carousel: HTMLElement | null = $state(null)

let context = $derived(getContext<WritableMessageAttachmentContext>(contentMessageAttachmentKey))
let attachment = $derived($context.attachment as Attachment.Cards)

const onChange = (event: { currentSlide: number; slideCount: number }) => {
	if (!carousel) return
	const messageGroup: HTMLElement | null = (carousel as Element).closest('.message-group')
	const avatar: Element | null = messageGroup && messageGroup.getElementsByClassName('avatar-element')[0]
	if (!avatar) return
	if (carousel && event.currentSlide > 0) {
		avatar.setAttribute('style', 'opacity: 0; transition: opacity 100ms;')
	} else {
		avatar.setAttribute('style', 'opacity: 1; transition: opacity 600ms;')
	}
}
</script>

{#if attachment.items.length > 1}
	{#key $isMessengerFrameExpanded}
		<div
			class={`${$isMessengerFrameExpanded ? 'w-116' : 'w-56'} relative ${
				$context.messageContext.group.align.isRight ? 'mr-4' : ''
			}`}
			bind:this={carousel}
		>
			<Carousel {onChange} controls={!isTouchDevice()} perPage={$isMessengerFrameExpanded ? 2 : 1}>
				{#each attachment.items as item, index (index)}
					<Card card={item} />
				{/each}
			</Carousel>
		</div>
	{/key}
{:else}
	<Card card={attachment.items[0]} />
{/if}
